/* Only tracks the existing panel index for content-sized layout. */
(() => {
  const init = () => {
    const drawer = document.getElementById('header-sidebar-menu');
    if (!drawer || drawer.dataset.compactReady) return;
    drawer.dataset.compactReady = 'true';
    drawer.dataset.compactPanel = '0';
    drawer.addEventListener('click', event => {
      const button = event.target.closest('button[data-panel]');
      if (button && drawer.contains(button)) drawer.dataset.compactPanel = button.dataset.panel.split('-')[0];
    });
    drawer.addEventListener('dialog:after-hide', () => { drawer.dataset.compactPanel = '0'; });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
